module.exports = __webpack_public_path__ + "b04a314fe889242d23afb882b6f70055.MP3";